import React, { Component } from "react";
import Header from "../../components/header/Header";
import OutdoorsContent from "../../containers/outdoors/OutdoorsContent";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";

class Outdoors extends Component {
  render() {
    return (
      <div>
        <Header theme={this.props.theme} />
        <OutdoorsContent theme={this.props.theme} />
        <Footer theme={this.props.theme} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Outdoors;
